import React from 'react';
import { Globe, LayoutGrid, Car } from 'lucide-react';
import bgImage from '../assets/image00048.jpeg';
import MyImage1 from '../assets/tariff.jpeg'; 
import india from '../assets/Certifications/india.jpeg';
import iatoLogo from '../assets/Certifications/1.jpg';
import ittaLogo from '../assets/Certifications/2.jpg';
import skalLogo from '../assets/Certifications/3.png';
import minis from '../assets/Certifications/ministry.jpeg';
import nla from '../assets/Certifications/nla.jpeg';

const About = () => {
  const objectives = [
    { 
      icon: <Globe size={24} />, 
      title: "PAN India Coverage", 
      desc: "ETC offers PAN India services with branch offices in Chennai, Bangalore, Hyderabad, New Delhi, Bhopal, and Pune. We also operate in major cities like Mumbai, Kolkata, Puducherry, Nagpur and throughout India." 
    },
    { 
      icon: <LayoutGrid size={24} />, 
      title: "Tier 2 & 3 Expansion", 
      desc: "Looking at the growing demand in tier 2 and tier 3 cities, we have effectively expanded our services for commercial and ground transportation needs for more than 120 cities" 
    },
    { 
      icon: <Car size={24} />, 
      title: "Technology Driven", 
      desc: "ETC is equipped with in-house technology and a new-age mobile tool app to cater to corporate employees and travel managers. Our technology delivers cost-effective, transparent, and reliable travel experiences." 
    },
  ];

  const carouselLogos = [
    { src: minis, alt: "Ministry of Tourism", name: "Government of India." },
    { src: iatoLogo, alt: "IATO", name: "Recognized by Ministry of Tourism Government of India." },
    { src: ittaLogo, alt: "ITTA", name: "Affiliations: IATO- Indian Association of Tour Operators." },
    { src: nla, alt: "NLA", name: "Member -National Limousine Association." },
    { src: skalLogo, alt: "SKAL", name: "Member-SKAL International." },
    { src: india, alt: "India Map", name: "All India Car Rental" },
    // Duplicate for seamless loop
    { src: minis, alt: "Ministry of Tourism", name: "Government of India." },
    { src: iatoLogo, alt: "IATO", name: "Recognized by Ministry of Tourism Government of India." },
    { src: ittaLogo, alt: "ITTA", name: "Affiliations: IATO- Indian Association of Tour Operators." },
    { src: nla, alt: "NLA", name: "Member -National Limousine Association." },
    { src: skalLogo, alt: "SKAL", name: "Member-SKAL International." },
    { src: india, alt: "India Map", name: "All India Car Rental" },
  ];

  return (
    <div className="bg-white font-sans text-slate-900 overflow-hidden">
      
      {/* 1. HERO SECTION */}
      <section 
        className="relative bg-cover bg-fixed bg-center px-6 text-center text-white border-b border-white/5 flex items-center justify-center h-[95vh]"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        {/* Overlay - Dark gradient for better text visibility */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1128]/90 via-[#0a1128]/80 to-[#0a1128]/95 z-0"></div>
        
        <div className="max-w-4xl mx-auto relative z-10 w-full">
          <p className="text-white font-bold tracking-[0.4em] uppercase text-[11px] mb-6 italic animate-pulse">
            Established Since 1999
          </p>
          
          <h1 className="text-5xl md:text-7xl font-black mb-8 uppercase tracking-tighter leading-[0.85]">
            About <br />
            <span className="text-blue-500 italic">Express Travel</span>
          </h1>

          <div className="max-w-2xl mx-auto border-l-4 border-blue-600 pl-8 text-left py-2">
            <p className="text-gray-300 text-lg md:text-xl leading-relaxed italic font-medium">
              "Clients are our Prime Assets. We nurture a culture founded on TRUST, PRIDE and TEAM WORK."
            </p>
          </div>
        </div>
      </section>

     {/* 2. CONTENT SECTION: ABOUT US */}
<section className="max-w-6xl mx-auto py-10 px-6 grid md:grid-cols-2 gap-12 items-center">
  
  {/* Image Container - Responsive Fix */}
  <div className="relative h-[300px] md:h-[400px] w-full">
    <div className="md:absolute md:top-0 md:right-0 md:w-[135%] w-full h-full rounded-none md:rounded-none overflow-hidden border-2 border-white shadow-2xl z-10"> 
      <img 
        src={MyImage1} 
        className="w-full h-full object-cover" 
        alt="Express Travel Fleet" 
      />
    </div>
  </div>

        <div className="space-y-6">
          <div className="flex flex-col gap-1">
            <p className="text-blue-600 font-bold uppercase text-[12px] tracking-[0.2em]">
              About Express Travel Corporate Services
            </p>
            <h2 className="text-5xl font-black text-[#001233] uppercase leading-none tracking-tighter">
              About Us
            </h2>
          </div>

          <div className="space-y-4">
            <div className="space-y-1">
              <h3 className="text-xl font-black text-slate-900 leading-tight uppercase">
                DRIVE IN INDIA <br /> & OVERSEAS
              </h3>
              <p className="text-blue-600 font-bold text-[11px] uppercase tracking-widest">
                A CAR FOR EVERY NEED
              </p>
            </div>

            <div className="text-slate-600 text-[15px] leading-relaxed space-y-4">
              <p className="italic font-semibold text-slate-800 border-l-4 border-blue-600 pl-4 py-1 bg-blue-50/50">
                "We have a range of cars, so something will perfectly fit your trip"
              </p>
              
              <p className="text-justify font-medium">
                <span className="font-bold text-[#001233]">Express Travel Corporate Services Pvt Ltd</span> (recognized by the Government of India, Ministry of Tourism), referred to as ETC, was established in 1999 to provide MNCs and large organizations with a superior travel experience that enhances the daily commute. ETC offers secure, convenient, enjoyable, and connected travel. ETC has evolved into a highly successful business, specializing in luxury car services for Corporate Clients, VVIP’s, Events, Consulates, and MICE, with a strong focus on the travel industry.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. MISSION, PHILOSOPHY & VISION */}
      <div className="relative bg-cover bg-fixed bg-center py-20 px-6" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="absolute inset-0 bg-black/85 z-0"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
            <div className="bg-white/5 backdrop-blur-md p-8 rounded-xl border border-white/10 shadow-xl">
              <h3 className="text-xl font-bold text-blue-400 mb-3 italic">"Our Mission"</h3>
              <p className="text-gray-300 text-sm leading-relaxed">To provide safe, reliable, and cost-effective travel solutions through innovation and customer-centricity.</p>
            </div>

            <div className="bg-white/5 backdrop-blur-md p-8 rounded-xl border border-white/10 shadow-xl">
              <h3 className="text-xl font-bold text-blue-400 mb-3 italic">"Our Vision"</h3>
              <p className="text-gray-300 text-sm leading-relaxed">To be the most preferred travel partner globally by setting benchmarks in service quality with technology</p>
            </div>
          </div>
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-black text-white uppercase tracking-tighter">Scope & <span className="text-blue-500">Objectives</span></h2>
            <div className="w-16 h-1 bg-blue-500 mx-auto mt-3 rounded-full"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {objectives.map((obj, i) => (
              <div key={i} className="bg-white/10 backdrop-blur-lg p-6 rounded-xl border border-white/10 group transition-all duration-300 hover:bg-white/20">
                <div className="mb-4 p-3 bg-blue-500/20 w-fit rounded-xl text-blue-400 group-hover:bg-blue-500 group-hover:text-white transition-colors">{obj.icon}</div>
                <h3 className="text-lg font-black mb-2 uppercase text-white leading-tight">{obj.title}</h3>
                <p className="text-white text-sm font-bold leading-relaxed">{obj.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="h-10 bg-white w-full"></div>

      {/* --- STATS SECTION --- */}
      <section className="bg-blue-50 py-12 px-6 border-y border-blue-100 rounded-xl mx-4 md:mx-10 shadow-sm">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 divide-x-0 md:divide-x md:divide-blue-200">
            <div className="text-center">
              <h2 className="text-5xl font-black text-[#001233] mb-1 tracking-tighter">1500+</h2>
              <p className="text-blue-600 font-extrabold text-[10px] uppercase tracking-widest">Fleet Vehicles</p>
            </div>
            <div className="text-center">
              <h2 className="text-5xl font-black text-[#001233] mb-1 tracking-tighter">25+</h2>
              <p className="text-blue-600 font-extrabold text-[10px] uppercase tracking-widest">Years Experience</p>
            </div>
            <div className="text-center">
              <h2 className="text-5xl font-black text-[#001233] mb-1 tracking-tighter">120+</h2>
              <p className="text-blue-600 font-extrabold text-[10px] uppercase tracking-widest">Cities Covered</p>
            </div>
            <div className="text-center">
              <h2 className="text-5xl font-black text-[#001233] mb-1 tracking-tighter">1000+</h2>
              <p className="text-blue-600 font-extrabold text-[10px] uppercase tracking-widest">Happy Clients</p>
            </div>
            <div className="text-center">
              <h2 className="text-5xl font-black text-[#001233] mb-1 tracking-tighter">24/7</h2>
              <p className="text-blue-600 font-extrabold text-[10px] uppercase tracking-widest">Availability</p>
            </div>
          </div>
        </div>
      </section>

      <div className="h-10 bg-white w-full"></div>

      {/* 5. FOOTER STORY SECTION */}
      <footer 
        className="relative bg-cover bg-fixed bg-center py-12 px-6 text-white overflow-hidden" 
        style={{ 
          backgroundImage: `url(${bgImage})`,
          clipPath: 'polygon(0 8%, 10% 0, 90% 0, 100% 8%, 100% 100%, 0 100%)' 
        }}
      >
        <div className="absolute inset-0 bg-black/85 z-0"></div>

        <div className="max-w-6xl mx-auto relative z-10">
          <div className="text-center mb-8">
            <h2 className="text-5xl font-extrabold uppercase tracking-tighter text-white">
              Our <span className="text-blue-500">Story</span>
            </h2>
            <h4 className="mt-2 text-gray-300">From humble beginnings to becoming a trusted name in luxury transportation</h4>
            <div className="w-16 h-1 bg-blue-500 mx-auto mt-2 rounded-full"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-10 max-w-5xl mx-auto">
            <div className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 text-center">
              <Globe className="mx-auto text-blue-400 mb-4" size={32} />
              <h4 className="text-xl font-bold uppercase tracking-tight text-white mb-3 italic">"Our Foundation"</h4>
              <p className="text-gray-200 text-base leading-relaxed font-medium">
                With dynamic leadership and hard work, our vision has enabled us to carve a special niche in the travel industry. We operate nearly 1500 fleets ranging from SEDAN to High End Luxury Cars.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10 text-center">
              <LayoutGrid className="mx-auto text-blue-400 mb-4" size={32} />
              <h4 className="text-xl font-bold uppercase tracking-tight text-white mb-3 italic">"Our Philosophy"</h4>
              <p className="text-gray-200 text-base leading-relaxed font-medium">
                Our business philosophy is based on our belief that clients are our prime assets. We nurture a culture founded on TRUST, PRIDE, and TEAM WORK.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* --- COMPACT INFINITE CAROUSEL SECTION --- */}
<section className="bg-white py-8 px-4 overflow-hidden relative">
  <div className="max-w-7xl mx-auto relative">
    <p className="text-blue-600 font-bold tracking-[0.2em] uppercase text-[12px] mb-6 text-center opacity-80">
      Memberships & Certifications
    </p>
    
    <div className="flex overflow-hidden group">
      {/* Container with smaller gap (gap-8 instead of 12) */}
      <div className="flex animate-scroll gap-8 py-2">
        {[...carouselLogos, ...carouselLogos].map((logo, index) => (
          <div 
            key={index} 
            className="flex-shrink-0 flex flex-col items-center w-48 transition-all duration-300 hover:scale-105"
          >
            {/* Image Container - Colors always visible */}
            <div className="bg-white p-3 border border-slate-100 flex items-center justify-center h-24 w-full shadow-sm rounded-lg mb-3">
              <img 
                src={logo.src} 
                alt={logo.alt} 
                className="max-h-[80%] max-w-[80%] object-contain" 
              />
            </div>
            
            {/* Compact Text Container */}
            <div className="w-full px-1">
              <p className="text-[#001233] font-semibold text-[11px] uppercase tracking-normal text-center leading-tight min-h-[32px] flex items-center justify-center">
                {logo.name}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
 </div>

        <style>{`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            display: flex;
            animation: scroll 45s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}</style>
      </section>
    </div>
  );
};

export default About;